import { useAppState } from '@/app/providers/AppStateProvider'
import { AttachFileTrigger } from '@/features/ingestion'
import { Icon } from '@/shared/ui/Icon'

/**
 * Step 13.7-FIX — recovery affordances shown under a ``no_context`` assistant
 * message. They only OPEN existing controls — they never send a message, never
 * create a conversation, and never mutate scope themselves:
 *   - "Selecionar escopo"      → opens the Composer's case Scope Selector
 *   - "Selecionar referências" → opens the Composer's Reference Picker
 *   - "Anexar documento"       → opens the Guided Ingestion file picker/dialog
 *
 * The selector overlays live in the Composer but their open-state is lifted to
 * AppStateProvider, so opening them from here just flips a shared flag. The
 * attach button reuses {@link AttachFileTrigger} (the same trusted-gesture file
 * input the composer uses) so no direct-to-R2 / browser upload is introduced.
 */
export function NoContextActions() {
  const { openScopeSelector, openReferencePicker } = useAppState()

  return (
    <div
      className="mt-2 flex flex-wrap items-center gap-1.5"
      aria-label="Ações para recuperar contexto"
      data-testid="no-context-actions"
    >
      <button
        type="button"
        className="tool-btn"
        data-testid="no-context-select-scope"
        title="Abrir o seletor de escopo de caso"
        onClick={openScopeSelector}
      >
        <Icon name="grid" size={13} /> Selecionar escopo
      </button>
      <button
        type="button"
        className="tool-btn"
        data-testid="no-context-select-references"
        title="Abrir o seletor de referências"
        onClick={openReferencePicker}
      >
        <Icon name="book" size={13} /> Selecionar referências
      </button>
      <AttachFileTrigger
        className="tool-btn"
        title="Anexar um documento para esta consulta"
        ariaLabel="Anexar documento"
        data-testid="no-context-attach"
      >
        <Icon name="paperclip" size={13} /> Anexar documento
      </AttachFileTrigger>
    </div>
  )
}
